/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_How_ForearmInputs */

const en_us2_body_measures_how_forearm = /** @type {(inputs: Body_Measures_How_ForearmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Around the thickest part, just below the elbow. Arm straight at your side, hand open and relaxed.`)
};

const pt_br2_body_measures_how_forearm = /** @type {(inputs: Body_Measures_How_ForearmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na parte mais grossa, logo abaixo do cotovelo. Braço estendido ao lado do corpo, mão aberta e relaxada.`)
};

const es_419_body_measures_how_forearm = /** @type {(inputs: Body_Measures_How_ForearmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En la parte más gruesa, justo debajo del codo. Brazo extendido al costado, mano abierta y relajada.`)
};

const pt_pt2_body_measures_how_forearm = /** @type {(inputs: Body_Measures_How_ForearmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na parte mais grossa, logo abaixo do cotovelo. Braço estendido ao lado do corpo, mão aberta e relaxada.`)
};

const fr_fr2_body_measures_how_forearm = /** @type {(inputs: Body_Measures_How_ForearmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Au plus épais, juste sous le coude. Bras tendu le long du corps, main ouverte et relâchée.`)
};

const de_de2_body_measures_how_forearm = /** @type {(inputs: Body_Measures_How_ForearmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An der dicksten Stelle, direkt unter dem Ellbogen. Arm gestreckt seitlich am Körper, Hand offen und entspannt.`)
};

const it_it2_body_measures_how_forearm = /** @type {(inputs: Body_Measures_How_ForearmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nel punto più spesso, appena sotto il gomito. Braccio disteso lungo il fianco, mano aperta e rilassata.`)
};

/**
* | output |
* | --- |
* | "Around the thickest part, just below the elbow. Arm straight at your side, hand open and relaxed." |
*
* @param {Body_Measures_How_ForearmInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_how_forearm = /** @type {((inputs?: Body_Measures_How_ForearmInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_How_ForearmInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_how_forearm(inputs)
	if (locale === "es-419") return es_419_body_measures_how_forearm(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_how_forearm(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_how_forearm(inputs)
	if (locale === "de-DE") return de_de2_body_measures_how_forearm(inputs)
	if (locale === "it-IT") return it_it2_body_measures_how_forearm(inputs)
	return en_us2_body_measures_how_forearm(inputs)
});
export { body_measures_how_forearm as "body-measures.how_forearm" }